import { Helmet } from 'react-helmet-async';
import {
    canonicalUrlFor,
    fullTitle,
    getSeoForPath,
    OG_IMAGE_ALT,
    OG_IMAGE_HEIGHT,
    OG_IMAGE_WIDTH,
    ogImageUrl,
    organizationJsonLd,
    SITE_NAME
} from 'seo/pages';

interface ISEOProps {
    pathname: string;
}

const SEO = ({ pathname }: ISEOProps) => {
    const page = getSeoForPath(pathname);
    const title = fullTitle(page.title);
    const canonicalUrl = canonicalUrlFor(page.canonicalPath);

    return (
        <Helmet prioritizeSeoTags>
            <html lang="it" />
            <title>{title}</title>
            <meta name="description" content={page.description} />
            <meta name="robots" content={page.noindex ? 'noindex, follow' : 'index, follow'} />
            <link rel="canonical" href={canonicalUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={page.description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:locale" content="it_IT" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:image" content={ogImageUrl} />
            <meta property="og:image:alt" content={OG_IMAGE_ALT} />
            <meta property="og:image:width" content={String(OG_IMAGE_WIDTH)} />
            <meta property="og:image:height" content={String(OG_IMAGE_HEIGHT)} />
            <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
        </Helmet>
    );
};

export default SEO;
